import {
  CartServices,
  getObjectKeysAsObject,
  ContactInformationServices,
  CardPaymentServices,
} from "@capone/checkout";

import { checkoutServices } from "./common";

import {
  AdditionalDetailsServices,
  ActivityTravelerServices,
} from "../../../../checkout";

export const Services: any = {
  ...CartServices,
  ...checkoutServices,
  ...ContactInformationServices,
  ...CardPaymentServices,
  ...AdditionalDetailsServices,
  ...ActivityTravelerServices,
};

export const ServiceTypes = getObjectKeysAsObject(Services);
